<template>
  <div id="open-platform">
    <common-header></common-header>
    <!-- banner -->
    <div class="banner">
      <div class="content-width">
        <pub-animate>
          <div v-show="showNavPic" class="banner-block" style="height:100%">
            <div class="fl">
              <h1 class="ft36">{{ lanInfo.title[6] }}</h1>
              <p v-html="lanInfo.bannerContent"></p>
            </div>
            <div class="fr">
              <img src="../../assets/images/openPlatform/banner-jjfa.png" alt style="width: 491px">
            </div>
          </div>
        </pub-animate>
      </div>
    </div>
    <!--  平台优势  -->
    <div class="legal-x-chain">
      <div class="open-platform-header-text">
        <h1>{{ lanInfo.title[7] }}</h1>
      </div>
      <div class="list-block content-width">
        <div class="list-item" v-for="(item, index) of lanInfo.infoList" :key="index">
          <span></span>
          <p>{{ item }}</p>
        </div>
      </div>
    </div>

    <!--  对接模式  -->
    <div class="open-platform-block">
      <div class="open-platform-header-text">
        <h1>{{ lanInfo.title[0] }}</h1>
      </div>
      <div class="docking-mode content-width">
        <div class="docking-item" v-for="(item, index) of lanInfo.dockingModeHeaders" :key="index"
             :class="{en: lanType == 'en'}">
          <div class="docking-header">
            <img :src="require(`../../assets/images/openPlatform/docking-${index + 1}.png`)">
            <h3>{{ item }}</h3>
          </div>
          <div class="docking-content">
            <div class="docking-content-item" v-for="contentItem of lanInfo.dockingModeContent[index]">
              <span></span>
              <p v-html="contentItem"></p>
            </div>
            <button @click="goPage(index)">{{ lanInfo.indexContent.more }}</button>
          </div>
        </div>
      </div>
    </div>

    <!--  联系我们  -->
    <open-platform-detail-contact-us></open-platform-detail-contact-us>
  </div>
</template>

<script>
import OpenPlatformDetailContactUs from "@/components/openPlatform/detailContactUs";

export default {
  name: "index",
  components: {OpenPlatformDetailContactUs},
  data() {
    return {
      hoverIndex: {
        header: 0,
        mode: 0
      },
      showNavPic: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.showNavPic = true;
    }, 1);
  },
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.openPlatform;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
  methods: {
    hoverAction(name, index) {
      this.hoverIndex[name] = index;
    },
    goPage(index) {
      const {href} = this.$router.resolve({
        path: `/${this.lanType}/detailsOpenPlatform?id=${index}`,
      });
      window.open(href, "_blank");
    }
  }
}
</script>

<style scoped lang="scss">
.content-width {
  width: 1200px;
  margin: 0 auto;
}

#open-platform {
  /* banner */
  .banner {
    width: 100%;
    height: 418px;
    background: #0e285a;

    .content-width {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      overflow: hidden;
    }

    .banner-block {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      img {
        cursor: pointer;
        transition: all 0.7s ease-in-out 0s;

        &:hover {
          transform: scale(1.1, 1.1);
        }
      }
    }

    h1 {
      font-size: 32px;
      color: #FFFFFF;
      line-height: 45px;
      margin-bottom: 14px;
      font-weight: 400;
    }

    p {
      font-size: 14px;
      color: #FFFFFF;
      line-height: 26px;
    }
  }

  /* 司法联盟链 */
  .legal-x-chain {
    background: #FAFAFA;

    .list-block {
      flex: 1;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .list-item {
        height: 270px;
        line-height: 28px;
        background: #fff;
        font-size: 14px;
        width: 290px;
        margin-right: 13px;
        margin-bottom: 26px;
        padding-top: 58px;

        span {
          width: 80px;
          height: 80px;
          display: block;
          margin: auto;
        }

        p {
          padding: 0 30px;
          margin-top: 16px;
          color: #646464;
          line-height: 24px;
          font-size: 15px;
        }


        &:nth-child(1) {
          span {
            background: url('../../assets/images/openPlatform/banner-1.png') no-repeat;
            background-size: 100%;
          }
        }

        &:nth-child(2) {
          span {
            background: url('../../assets/images/openPlatform/banner-2.png');
            background-size: 100%;
          }
        }

        &:nth-child(3) {
          span {
            background: url('../../assets/images/openPlatform/banner-3.png');
            background-size: 100%;
          }
        }

        &:nth-child(4) {
          span {
            background: url('../../assets/images/openPlatform/banner-4.png');
            background-size: 100%;
          }
        }

        &:nth-child(5) {
          span {
            background: url('../../assets/images/openPlatform/banner-5.png');
            background-size: 100%;
          }
        }

        &:nth-child(6) {
          span {
            background: url('../../assets/images/openPlatform/banner-6.png');
            background-size: 100%;
          }
        }

        &:nth-child(7) {
          span {
            background: url('../../assets/images/openPlatform/banner-7.png');
            background-size: 100%;
          }
        }

        &:nth-child(8) {
          span {
            background: url('../../assets/images/openPlatform/banner-8.png');
            background-size: 100%;
          }
        }

        &:nth-child(4n) {
          margin-right: 0;
        }

        &:hover {
          background: #04275D;

          p {
            color: #fff;
          }

          &:nth-child(1) {
            span {
              background: url('../../assets/images/openPlatform/banner-h-1.png');
              background-size: 100%;
            }
          }

          &:nth-child(2) {
            span {
              background: url('../../assets/images/openPlatform/banner-h-2.png');
              background-size: 100%;
            }
          }

          &:nth-child(3) {
            span {
              background: url('../../assets/images/openPlatform/banner-h-3.png');
              background-size: 100%;
            }
          }

          &:nth-child(4) {
            span {
              background: url('../../assets/images/openPlatform/banner-h-4.png');
              background-size: 100%;
            }
          }

          &:nth-child(5) {
            span {
              background: url('../../assets/images/openPlatform/banner-h-5.png');
              background-size: 100%;
            }
          }

          &:nth-child(6) {
            span {
              background: url('../../assets/images/openPlatform/banner-h-6.png');
              background-size: 100%;
            }
          }

          &:nth-child(7) {
            span {
              background: url('../../assets/images/openPlatform/banner-h-7.png');
              background-size: 100%;
            }
          }

          &:nth-child(8) {
            span {
              background: url('../../assets/images/openPlatform/banner-h-8.png');
              background-size: 100%;
            }
          }
        }

        &.active {
          color: #0176D9;
          cursor: pointer;
        }
      }
    }
  }

  /* end */

  /* 公共标题 */
  .open-platform-header-text {
    text-align: center;
    padding: 40px 0;

    h1 {
      color: #000000;
      font-size: 26px;
    }
  }

  /* end */

  .open-platform-block {
    background: #fff;
  }

  /* 对接模式 */
  .docking-mode {
    display: flex;
    padding-bottom: 40px;

    .docking-item {
      background: #FAFAFA;
      width: 538px;
      margin-right: 3px;
      padding-left: 60px;
      padding-right: 60px;
      padding-bottom: 32px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      &:nth-child(3) {
        margin-right: 0;
      }

      .docking-header {
        border-bottom: 2px solid #fff;
        padding-bottom: 25px;
        padding-top: 28px;
        display: flex;

        img {
          width: 24px;
          height: 24px;
          margin-right: 4px;
        }

        h3 {
          color: #0A0A0A;
          font-size: 18px;
          line-height: 25px;
        }
      }

      .docking-content {
        padding-top: 29px;

        .docking-content-item {
          margin-bottom: 24px;
          display: flex;
          flex-direction: row;

          span {
            width: 6px;
            height: 6px;
            background: #D8D8D8;
            display: inline-block;
            margin-right: 14px;
            margin-left: 8px;
            margin-top: 7px;
            flex-shrink: 0;
          }

          p {
            font-size: 14px;
            color: #787878;
            line-height: 20px;
            height: 40px;
          }
        }

      }

      button {
        border: 1px solid #0A57C9;
        color: #0A57C9;
        line-height: 20px;
        font-size: 14px;
        text-align: center;
        height: 38px;
        width: 100%;
        background: #fff;
      }

      &:hover {
        background: #F5F5F5;

        button {
          background: #0A57C9;
          color: #fff;
        }
      }

      &.en {
        .docking-header {
          h3 {
            height: 75px;
          }
        }

        .docking-content-item {
          p {
            height: 80px;
          }
        }
      }
    }
  }
}

</style>